export default __webpack_public_path__ + "static/media/Tablet.5bbd953f.png";